'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _traverse = require('traverse');

var _traverse2 = _interopRequireDefault(_traverse);

var _actionTypes = require('../action-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getParentIds = function getParentIds(values, data) {
	if (data.key !== 'children') {
		return data.parent ? getParentIds([data.node.categoryId].concat(_toConsumableArray(values)), data.parent) : [data.node.categoryId].concat(_toConsumableArray(values));
	}

	return data.parent ? getParentIds(values, data.parent) : values;
};

var findNodeAndParentIds = function findNodeAndParentIds(tree, matcher) {
	var parentIds = [];
	var matchedNode = void 0;

	(0, _traverse2.default)(tree).forEach(function (node) {
		if (matcher(node)) {
			this.stop();

			matchedNode = node.categoryId;

			if (this.parent) {
				parentIds = getParentIds([], this.parent);
			}
		}
	});

	return {
		nodeId: matchedNode,
		parentIds: parentIds
	};
};

var initialState = exports.initialState = {
	open: {}
};

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _actionTypes.CMS_COMPONENT_SUB_MENU_TOGGLE:
			{
				var _action$payload = action.payload,
				    categoryId = _action$payload.categoryId,
				    closeOthers = _action$payload.closeOthers,
				    componentId = _action$payload.componentId,
				    tree = _action$payload.tree;

				var openState = state.open[componentId] || [];
				var isOpen = openState.includes(categoryId);

				if (closeOthers) {
					var _findNodeAndParentIds = findNodeAndParentIds(tree, function (node) {
						return node.categoryId === categoryId;
					}),
					    parentIds = _findNodeAndParentIds.parentIds;

					return _extends({}, state, {
						open: _extends({}, state.open, _defineProperty({}, componentId, isOpen ? parentIds : parentIds.concat(categoryId)))
					});
				}

				return _extends({}, state, {
					open: _extends({}, state.open, _defineProperty({}, componentId, isOpen ? openState.filter(function (id) {
						return id !== categoryId;
					}) : openState.concat(categoryId)))
				});
			}
		case _actionTypes.CMS_COMPONENT_SUB_MENU_DEFAULT_OPEN:
			{
				var _action$payload2 = action.payload,
				    activePath = _action$payload2.activePath,
				    _componentId = _action$payload2.componentId,
				    _tree = _action$payload2.tree;

				var path = activePath.startsWith('/') ? activePath.substring(1) : activePath;

				var _findNodeAndParentIds2 = findNodeAndParentIds(_tree, function (x) {
					return x && x.linkFriendlyName === path;
				}),
				    nodeId = _findNodeAndParentIds2.nodeId,
				    _parentIds = _findNodeAndParentIds2.parentIds;

				return _extends({}, state, {
					open: _extends({}, state.open, _defineProperty({}, _componentId, _parentIds.concat(nodeId)))
				});
			}
		default:
			{
				return state;
			}
	}
};